import React from "react";
import { Box, Container, Link as MuiLink, Typography } from "@mui/material";
import { SecurityOutlined } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

import { footerBrand, footerLegalLinks, footerSections } from "../config/footerConfig";
import "../editorial.css";

const isExternalLink = (href) => /^(https?:|mailto:|tel:)/.test(href);

function FooterLink({ href, children }) {
  const external = isExternalLink(href);
  return (
    <MuiLink
      component={external ? "a" : RouterLink}
      href={external ? href : undefined}
      to={external ? undefined : href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
      underline="none"
      className="marketing-footer-link"
    >
      {children}
    </MuiLink>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" className="marketing-footer">
      <Container maxWidth={false} className="marketing-footer-container">
        <Box className="marketing-footer-grid">
          <Box className="marketing-footer-brand">
            <Typography component="p">Evaluate Yourself</Typography>
            <Typography component="p">{footerBrand.tagline}</Typography>
          </Box>
          {footerSections.map((section) => (
            <Box component="nav" aria-label={`${section.title} footer links`} key={section.title}>
              <Typography component="h2">{section.title}</Typography>
              <Box className="marketing-footer-links">
                {section.links.map((link) => (
                  <FooterLink key={`${section.title}-${link.label}`} href={link.href}>{link.label}</FooterLink>
                ))}
              </Box>
            </Box>
          ))}
        </Box>

        <Typography component="p" aria-hidden="true" className="marketing-footer-wordmark">
          Evaluate Yourself
        </Typography>

        <Box className="marketing-footer-bottom">
          <Box className="marketing-footer-security">
            <SecurityOutlined />
            <Typography component="span">Your practice data is private and secure.</Typography>
          </Box>
          <Box className="marketing-footer-legal">
            <Typography component="span">© {year} {footerBrand.legalName}. All rights reserved. Built by Ignitz Solutions.</Typography>
            {footerLegalLinks.map((link) => <FooterLink key={link.label} href={link.href}>{link.label}</FooterLink>)}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
